import { useAuthStore } from '../store/authStore';
import { signOut } from '../services/cognito';
import { useNavigate } from 'react-router-dom';

export default function PendingPage() {
  const { user, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    clearAuth();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">⏳</span>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Awaiting Approval
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for registering, {user?.givenName}! Your account is pending approval
          from a family administrator.
        </p>
        
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-amber-800">
            You'll receive an email once your account has been approved and you can start
            sharing photos with the family.
          </p>
        </div>

        <button
          onClick={handleSignOut}
          className="w-full px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}

